import { render, staticRenderFns } from "./ShelfScan.vue?vue&type=template&id=27740e12&scoped=true"
import script from "./ShelfScan.vue?vue&type=script&lang=js"
export * from "./ShelfScan.vue?vue&type=script&lang=js"
import style0 from "./ShelfScan.vue?vue&type=style&index=0&id=27740e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27740e12",
  null
  
)

export default component.exports